import { api } from '../middleware/api';

export interface AmAsset {
  as_id: number;
  as_company: string;
  as_code: string;
  as_name: string;
  as_category?: number;
  ct_name?: string;
  as_product?: number | null;
  product_name?: string;
  product_brand?: string;
  product_model?: string;
  dp_name?: string;
  photo_id?: number | null;
  bookValue?: number | null;
  as_notes?: string;
  /** Create-only: number of assets to create (CODE-1..CODE-N) */
  qty?: number;
  as_qty?: number;
  as_department?: number;
  as_location?: string;
  as_room?: string | null;
  as_loctype?: 'PUBLIC' | 'HALL' | null;
  as_locref?: number | null;
  loc_name?: string | null;
  loc_access?: 'P' | 'S' | 'M';
  as_serialno?: string;
  as_purchasedate?: string;
  as_purchasecost?: number;
  as_supplier?: number;
  as_invoiceno?: string;
  as_depmethod?: string;
  as_deprate?: number;
  as_usefullife?: number;
  as_salvagevalue?: number;
  as_status: string;
  as_purchase?: number;
  as_uid?: string;
  as_cdt?: string;
  as_muid?: string;
  as_mdt?: string;
}

export const amassetApi = api
  .enhanceEndpoints({ addTagTypes: ['AmAsset'] })
  .injectEndpoints({
    endpoints: builder => ({
      getAmAssets: builder.query<AmAsset[], string>({
        query: (company) => `amasset?company=${company}`,
        providesTags: ['AmAsset']
      }),
      getAmAssetsByCategory: builder.query<AmAsset[], { company: string; category: number }>({
        query: ({ company, category }) => `amasset/category/${category}?company=${company}`,
        providesTags: ['AmAsset']
      }),
      // First unused asset code at or after `code` (`taken` = codes already used on other unsaved lines)
      getAmNextCode: builder.query<{ code: string; changed: boolean }, { code: string; taken?: string }>({
        query: ({ code, taken }) =>
          `amasset/nextcode?code=${encodeURIComponent(code)}&taken=${encodeURIComponent(taken || '')}`,
        keepUnusedDataFor: 0
      }),
      getAmAssetById: builder.query<AmAsset, number>({
        query: (id) => `amasset/byid/${id}`,
        providesTags: ['AmAsset']
      }),
      insertAmAsset: builder.mutation<{ as_id: number; as_ids?: number[] }, Partial<AmAsset>>({
        query: (body) => ({
          url: 'amasset',
          method: 'POST',
          body
        }),
        invalidatesTags: ['AmAsset']
      }),
      updateAmAsset: builder.mutation<{ as_id: number }, AmAsset>({
        query: (body) => ({
          url: 'amasset',
          method: 'PUT',
          body
        }),
        invalidatesTags: ['AmAsset']
      }),
      deleteAmAsset: builder.mutation<{ message: string }, number>({
        query: (id) => ({
          url: `amasset/${id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['AmAsset']
      })
    }),
    overrideExisting: false
  });

export const {
  useGetAmAssetsQuery,
  useGetAmAssetsByCategoryQuery,
  useGetAmAssetByIdQuery,
  useLazyGetAmNextCodeQuery,
  useInsertAmAssetMutation,
  useUpdateAmAssetMutation,
  useDeleteAmAssetMutation
} = amassetApi;
